import { cn } from '../lib/utils';
import { Trophy } from 'lucide-react';

export function TicketNumber({ number, isWinner = false, className }) {
  return (
    <div 
      className={cn(
        "ticket-number inline-flex items-center gap-2",
        isWinner && "bg-gradient-to-r from-emerald-400 to-emerald-500 text-white",
        className
      )}
      data-testid={`ticket-${number}`}
    >
      {isWinner && <Trophy className="w-4 h-4" />}
      <span>{number}</span>
    </div>
  );
}
